import { render, staticRenderFns } from "./rejected-tab.vue?vue&type=template&id=15c62524"
import script from "./rejected-tab.vue?vue&type=script&lang=js"
export * from "./rejected-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports